import { useTitle } from 'ahooks'

export default function({ children }) {
  return R.defaultTo(null, useTitle(children, {
    restoreOnUnmount: false,
  }))
}
